import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerStatistics = (type: any, start: any, end: any) => {
  const customerId = useCustomerId()

  const query = { start, end }

  const getContactsStatistics = () => get(`/management/customers/${customerId}/${type}/statistics`, { query })

  return useQuery({
    queryKey: ['customer', customerId, 'metrics', type, query],
    queryFn: () => getContactsStatistics(),
    initialData: [],
    refetchOnWindowFocus: false,
  })
}
